import constants from '@/constants.js';

class ChartLabelGeneratorService {
    generateSnapChartLabelPattern (period, daySmoothing) {
        switch (period.key) {
        case constants.PERIOD.DAY:
            if (daySmoothing && daySmoothing > 1) {
                // Day Smoothing
                return 'Average for {0} to {1}';
            } else {
                // Single Day
                return 'Average for {0}';
            }
        case constants.PERIOD.WEEK:
            return 'Average for week from {0} to {1}';
        default:
            return 'Average for {0}';
        }
    }

    generateProgressChartLabelPattern (period, daySmoothing) {
        switch (period.key) {
        case constants.PERIOD.DAY:
            if (daySmoothing && daySmoothing > 1) {
                // Day Smoothing
                return '{2} day rolling average from {0} to {1}';
            } else {
                // Single Day
                return 'Days from {0} to {1}';
            }
        case constants.PERIOD.WEEK:
            return 'Averages for weeks from {0} to {1}';
        case constants.PERIOD.MONTH:
            return 'Averages for months from {0} to {1}';
        case constants.PERIOD.QUARTER:
            return 'Averages for quarters from {0} to {1}';
        case constants.PERIOD.YEAR:
            return 'Averages for years from {0} to {1}';
        default:
            return 'From {0} to {1}';
        }
    }

    formatString (stringPattern, ...args) {
        /* Explanation from https://regex101.com/
            "/{([^{}]*)}/g"
            { matches the character { literally (case sensitive)
                1st Capturing Group ([^{}]*)
                    Match a single character not present in the list below [^{}]*
                    * Quantifier — Matches between zero and unlimited times, as many times as possible, giving back as needed (greedy)
                    {} matches a single character in the list {} (case sensitive)
            } matches the character } literally (case sensitive)
            Global pattern flags
            g modifier: global. All matches (don't return after first match)
        */

        // RegEx "/{([^{}]*)}/g" produces a Full match and a Group match.
        // Example string: "Average for {0}", the regex will produce "{0}" as full match and "0" as group.
        // For each match we are extracting the index and finding the value from "args" and replacing the full match with the value.
        return stringPattern.replace(/{([^{}]*)}/g,
            function (fullMatch, matchedIndex) {
                var val = args[matchedIndex];
                return typeof val === 'string' || typeof val === 'number' ? val : fullMatch;
            }
        );
    };
};

export const chartLabelGeneratorService = new ChartLabelGeneratorService();
